import styled from 'styled-components'

export const CardWrapper = styled.div`
  position: relative;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  min-width: 0;
  max-width: ${props => props.maxWidth || 'auto'};
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid #e8eef1;
  border-radius: 0.25rem;
`

export const Header = styled.header`
  background: transparent;
  border-bottom: 0;
  padding: 0.85rem 1.25rem;
  margin-bottom: 0;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #eaeff5;
  justify-content: center;
  border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0;
`

export const H4 = styled.h4`
  line-height: 22px;
  font-size: 18px;
  color: #677897;
  margin-bottom: 0;
  font-weight: 500;
`

export const Body = styled.main`
  flex: 1 1 auto;
  padding: 40px;
`

export const CenterElement = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  flex-flow: wrap row;
`



// WEBPACK FOOTER //
// ./src/components/Card/theme.js